// extracted by mini-css-extract-plugin
export default {"main_root":"MainRoot_main_root__uCUnR"};